import qs from "qs-lite";
import { useMutation, useQuery, useQueryClient } from "react-query";
import api from "../../utils/api";
import { useHubSnackBar } from "../useSnackBar";
import { invalidate } from "../../helpers/clientHelper";
import { clearCachedItem } from "../../helpers";

const EMPLOYEE = "/employee";
const getAllEmployeeData = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${EMPLOYEE}?${queryString}`);
};

export const useGetAllEmployeeData = ({ defaultLocation = 1 }) => {
  const query = new URLSearchParams(window.location.search);

  const location = query.get("location") || defaultLocation;
  const status = query.get("status") || "All";

  const orderBy = query.get("orderBy") || "name";
  const sortOrder = query.get("sortOrder") || "asc";
  const limit = query.get("limit") || 100;
  const offset = query.get("offset") || 0;

  const queryProps = {
    limit,
    offset,
    orderBy,
    sortOrder,
    ...(!location || location === "All" ? {} : { location }),
    ...(status === "All" ? {} : { status }),
  };

  return useQuery([EMPLOYEE, queryProps], getAllEmployeeData);
};

const getEmployeeList = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${EMPLOYEE}/list?${queryString}`);
};
export const useGetEmployeeList = ({ location = null, enabled = true }) => {
  return useQuery([EMPLOYEE, { location }], getEmployeeList, { enabled });
};

const getEmployeeById = (id) => api.get(`${EMPLOYEE}/${id}`);
export const useGetEmployeeById = ({ id }) =>
  useQuery([EMPLOYEE, id], () => getEmployeeById(id));

const postCreateEmployee = (payload) => api.post(EMPLOYEE, payload);
export const usePostCreateEmployee = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateEmployee, {
    onSuccess: () => {
      invalidate(queryClient, EMPLOYEE);
      clearCachedItem("employees");
      addSnackbarSuccess({ message: "Successfully Created Employee" });
    },
  });
};

const putEmployeeData = (data) => {
  const id = data.id;
  delete data.id;
  return api.put(`${EMPLOYEE}/${id}`, data);
};
export const usePutEmployeeData = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(putEmployeeData, {
    onSuccess: () => {
      invalidate(queryClient, EMPLOYEE);
      clearCachedItem("employees");
      addSnackbarSuccess({ message: "Successfully Updated Employee" });
    },
  });
};
